import React, { useEffect, useRef } from 'react'
import * as styles from './links.module.scss'
import { Link } from 'gatsby'

import jose from '../../src/images/header/bw-2015-jose.jpg'
import physician from '../../src/images/header/bwTrentini_WithPhy.jpg'
import serviceMember from '../../src/images/header/applying-menu-image.jpg'
import educationTraining from '../../src/images/header/education-training-menu-img.jpg'
import careersImg from '../../src/images/header/careers-menu-image.jpg'
import armyLogo from '../../src/images/map/logo-army.png'
import navyLogo from '../../src/images/map/logo-navy.png'
import airForceLogo from '../../src/images/map/logo-airforce.png'

export const Hamburger = ({ open, setOpen }) => {
  useEffect(() => {
    document.body.style.position = open ? 'fixed' : ''
    document.body.style.overflow = open ? 'hidden' : ''
    document.body.style.height = open ? '100%' : ''
    document.body.style.width = open ? '100%' : ''
    document.body.style.touchAction = open ? 'none' : ''
  }, [open])
  return (
    <button className={styles.hamburger} onClick={() => setOpen(!open)}>
      {open ? <span className={styles.close}>&#x2715;</span> : <span>&#9776;</span>}
    </button>
  )
}
const Links = ({ open, activeLinkItem, setActiveLinkItem }) => {
  const linksRef = useRef(null)

  const handleClick = (e) => {
    const bottom = document.querySelector("[class^='links-module--links']").getBoundingClientRect().bottom
    e.target.parentElement.querySelector('ul').style.top = `${bottom}px`
    setActiveLinkItem((activeId) => (activeId === e.target.parentElement.id ? null : e.target.parentElement.id))
  }

  return (
    <div className={`${styles.links} ${open && styles.active} dropdown-menu`} ref={linksRef}>
      <div id="linkItem-0" className={styles.linkItem + ' dropdown-toggle nav-lifestyle'}>
        <button
          onClick={handleClick}
          className={`${activeLinkItem === 'linkItem-0' && styles.active} mobile-link-text`}
        >
          Military Medicine 101
        </button>
        <ul className={`${activeLinkItem === 'linkItem-0' && styles.active}`}>
          <h2>Military Medicine 101</h2>
          <img src={jose} alt="" />
          <li>
            <Link to="/military-medicine-101" className="nav-lifestyle" activeClassName={styles.active}>
              Overview
            </Link>
          </li>
          <li>
            <Link
              to="/military-medicine-101/about-military-medicine"
              className="nav-lifestyle"
              activeClassName={styles.active}
            >
              About Military Medicine
            </Link>
          </li>
          <li>
            <Link to="/military-medicine-101/service-branches" activeClassName={styles.active}>
              Service Branches
            </Link>
            <div className={styles.branches}>
              <Link
                to="/military-medicine-101/service-branches/army"
                className="nav-lifestyle"
                activeClassName={styles.active}
              >
                Army
              </Link>
              <Link
                to="/military-medicine-101/service-branches/navy"
                className="nav-lifestyle"
                activeClassName={styles.active}
              >
                Navy
              </Link>
              <Link
                to="/military-medicine-101/service-branches/air-force"
                className="nav-lifestyle"
                activeClassName={styles.active}
              >
                Air Force
              </Link>
            </div>
          </li>
          <li>
            <Link to="/military-medicine-101/career-pathways" className="nav-lifestyle" activeClassName={styles.active}>
              Career Pathways
            </Link>
          </li>
          <li className={styles.lastLi}>
            <Link
              to="/military-medicine-101/military-medical-advancements"
              className="nav-lifestyle"
              activeClassName={styles.active}
            >
              Military Medical Advancements
            </Link>
          </li>
          <div className={styles.bottomLinks}>
            <h3>Service Branches in Military Medicine</h3>
            <div className={styles.branches}>
              <Link
                to="/military-medicine-101/service-branches/army"
                className="nav-lifestyle"
                activeClassName={styles.active}
              >
                <img src={armyLogo} alt="U.S Army Logo" title="US Army" />
                <span>Army</span>
              </Link>
              <Link
                to="/military-medicine-101/service-branches/navy"
                className="nav-lifestyle"
                activeClassName={styles.active}
              >
                <img src={navyLogo} alt="U.S Navy Logo" title="US Navy" />
                <span>Navy</span>
              </Link>
              <Link
                to="/military-medicine-101/service-branches/air-force"
                className="nav-lifestyle"
                activeClassName={styles.active}
              >
                <img src={airForceLogo} alt="US Air Force Logo" title="US Air Force" />
                <span>Air Force</span>
              </Link>
            </div>
          </div>
        </ul>
      </div>
      <div id="linkItem-1" className={styles.linkItem}>
        <button onClick={handleClick} className={`${activeLinkItem === '' && styles.active}`}>
          Applying + What to Expect
        </button>
        <ul className={`${activeLinkItem === 'linkItem-1' && styles.active}`}>
          <h2>Applying + What to Expect</h2>
          <img src={serviceMember} alt="" />
          <li>
            <Link to="/applying-and-what-to-expect" activeClassName={styles.active}>
              Overview
            </Link>
          </li>
          <li>
            <Link to="/applying-and-what-to-expect/eligibility-requirements" activeClassName={styles.active}>
              Eligibility Requirements
            </Link>
          </li>
          <li>
            <Link to="/applying-and-what-to-expect/medical-school-programs" activeClassName={styles.active}>
              Medical School Programs
            </Link>
            <div>
              <Link to="/applying-and-what-to-expect/medical-school-programs/hpsp" activeClassName={styles.active}>
                Health Professionals Scholarship Program (HPSP)
              </Link>
              <Link to="/applying-and-what-to-expect/medical-school-programs/usu" activeClassName={styles.active}>
                Uniformed Services University of the Health Sciences (USU)
              </Link>
            </div>
          </li>
          <li>
            <Link to="/applying-and-what-to-expect/medical-residency-programs" activeClassName={styles.active}>
              Medical Residency Programs
            </Link>
          </li>
          <li>
            <Link to="/applying-and-what-to-expect/licensed-physicians" activeClassName={styles.active}>
              Licensed Physicians
            </Link>
          </li>
          <li>
            <Link to="/applying-and-what-to-expect/part-time-service-options" activeClassName={styles.active}>
              Part-Time Service Options
            </Link>
          </li>
        </ul>
      </div>
      <div id="linkItem-2" className={styles.linkItem}>
        <button onClick={handleClick} className={`${activeLinkItem === 'linkItem-2' && styles.active}`}>
          Education + Training
        </button>
        <ul className={`${activeLinkItem === 'linkItem-2' && styles.active}`}>
          <h2>Education + Training</h2>
          <img src={educationTraining} alt="alt" />
          <li>
            <Link to="/education-and-training" activeClassName={styles.active}>
              Overview
            </Link>
          </li>
          <li>
            <Link to="/education-and-training/military-officer-training" activeClassName={styles.active}>
              Military Officer Training
            </Link>
          </li>
          <li>
            <Link to="/education-and-training/attending-medical-school" activeClassName={styles.active}>
              Attending Medical School
            </Link>
          </li>
          <li>
            <Link to="/education-and-training/completing-a-residency" activeClassName={styles.active}>
              Completing a Residency
            </Link>
          </li>
          <li>
            <Link to="/education-and-training/general-medical-officers" activeClassName={styles.active}>
              General Medical Officers
            </Link>
          </li>
          <li>
            <Link
              to="/education-and-training/advanced-education-and-research-opportunities"
              activeClassName={styles.active}
            >
              Advanced Education + Research Opportunities
            </Link>
          </li>
        </ul>
      </div>
      <div id="linkItem-3" className={styles.linkItem}>
        <button onClick={handleClick} className={`${activeLinkItem === 'linkItem-3' && styles.active}`}>
          Careers + Lifestyle
        </button>
        <ul className={`${activeLinkItem === 'linkItem-3' && styles.active}`}>
          <h2>Careers + Lifestyle</h2>
          <img src={careersImg} alt="" />
          <li>
            <Link to="/career-and-lifestyle" activeClassName={styles.active}>
              Overview
            </Link>
          </li>
          <li>
            <Link to="/career-and-lifestyle/military-service-and-work-environment" activeClassName={styles.active}>
              Military Service + Work Environment
            </Link>
          </li>
          <li>
            <Link to="/career-and-lifestyle/medical-specialties-and-roles" activeClassName={styles.active}>
              Medical Specialties + Roles
            </Link>
          </li>
          <li>
            <Link to="/career-and-lifestyle/non-physician-careers-military" activeClassName={styles.active}>
              Non-Physician Careers in the Military
            </Link>
          </li>
          <li>
            <Link to="/career-and-lifestyle/military-medical-facilities-map" activeClassName={styles.active}>
              Military Medical Facilities Map
            </Link>
          </li>
          <li>
            <Link to="/career-and-lifestyle/physician-salary-and-compensation" activeClassName={styles.active}>
              Physician Salary + Compensation
            </Link>
          </li>
          <li>
            <Link to="/career-and-lifestyle/military-benefits-and-life-on-base" activeClassName={styles.active}>
              Military Benefits + Life on Base
            </Link>
          </li>
        </ul>
      </div>
      <div id="linkItem-4" className={styles.linkItem}>
        <button onClick={handleClick} className={`${activeLinkItem === 'linkItem-4' && styles.active}`}>
          Day in the Life
        </button>
        <ul className={`${activeLinkItem === 'linkItem-4' && styles.active}`}>
          <h2>Day in the Life</h2>
          <img src={physician} alt="" />
          <li>
            <Link to="/day-in-the-life" activeClassName={styles.active}>
              Overview
            </Link>
          </li>
          <li>
            <Link to="/day-in-the-life/sara-burdash" activeClassName={styles.active}>
              Sara Burdash, M.D.
            </Link>
          </li>
          <li>
            <Link to="/day-in-the-life/hunter-winegarner" activeClassName={styles.active}>
              Hunter Winegarner, M.D.
            </Link>
          </li>
          <li>
            <Link to="/day-in-the-life/josephine-nguyen" activeClassName={styles.active}>
              Josephine Nguyen, M.D.
            </Link>
          </li>
          <li>
            <Link to="/day-in-the-life/jonathan-forsberg" activeClassName={styles.active}>
              Jonathan Forsberg, M.D., Ph.D
            </Link>
          </li>
          <li>
            <Link to="/day-in-the-life/john-trentini" activeClassName={styles.active}>
              John Trentini, M.D., Ph.D
            </Link>
          </li>
        </ul>
      </div>
    </div>
  )
}

export default Links
